export default {"src":"/_next/static/image/public/images/Vector.1bc916f4dc5a2de5ed3c5029bea45919.svg","height":12,"width":12};